/**
 * Generate a readable, secure passcode (Zoom-style)
 * Format: Xxxx-Xxxx-Xxxx (e.g., Kx9m-Pq2v-R4nL)
 * ~77 bits of entropy
 */
export function generatePasscode(): string {
  // Charset excluding ambiguous characters (0, O, l, I, 1)
  const charset = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789";
  const segments = 3;
  const segmentLength = 4;
  const parts: string[] = [];

  for (let i = 0; i < segments; i++) {
    const bytes = new Uint8Array(segmentLength);
    crypto.getRandomValues(bytes);
    const segment = Array.from(bytes)
      .map((b) => charset[b % charset.length])
      .join("");
    parts.push(segment);
  }

  return parts.join("-");
}

/**
 * Validate passcode strength
 */
export function isPasscodeStrong(passcode: string): boolean {
  // At least 8 characters
  if (passcode.length < 8) return false;
  return true;
}
